import { mediaQueryUp } from 'components/utils/breakpoint'
import { css } from 'styled-components'
import config from 'constants/config'
import { generateCSSVarEntries, getThemeClassName } from 'lib/theme/themeUtils'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const ShadowsStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.shadows, 'shadow')))
const palettes = config.theme.palette
const borderRadii = config.theme.borderRadius

function getBorderRadiusStyles(version: keyof typeof borderRadii) {
  return css(Object.fromEntries(generateCSSVarEntries(borderRadii[version], 'border-radius')))
}

function getBorderRadiusScopeStyles(version: keyof typeof borderRadii, scope: string) {
  return css`
    ${scope} {
      ${getBorderRadiusStyles(version)}
    }
  `
}

function getPaletteStyle(palette: App.Design.Palette<string>) {
  return css(Object.fromEntries(generateCSSVarEntries(palette, 'palette')))
}

function getPaletteScopeStyles(version: keyof typeof palettes, scope: string) {
  const defaultStyle = getPaletteStyle(palettes[version].default)
  const inverseStyle = getPaletteStyle(palettes[version].inverse)
  const getThemeSelectors = (theme: Parameters<typeof getThemeClassName>[0]) => {
    const themeClass = getThemeClassName(theme)

    return `${scope}.${themeClass}, ${scope} .${themeClass}`
  }
  const defaultSelectors = `${scope}, ${getThemeSelectors({ mobile: 'default' })}`

  return css`
    ${defaultSelectors} {
      ${defaultStyle}
      color: var(--palette-neutral-surface-normal-contrast);
    }
    ${getThemeSelectors({ mobile: 'inverse' })} {
      ${inverseStyle}
      color: var(--palette-neutral-surface-normal-contrast);
    }
    ${mediaQueryUp.tablet} {
      ${getThemeSelectors({ tablet: 'default' })} {
        ${defaultStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
      ${getThemeSelectors({ tablet: 'inverse' })} {
        ${inverseStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
    }
    ${mediaQueryUp.desktop} {
      ${getThemeSelectors({ desktop: 'default' })} {
        ${defaultStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
      ${getThemeSelectors({ desktop: 'inverse' })} {
        ${inverseStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
    }
    ${mediaQueryUp.largeDesktop} {
      ${getThemeSelectors({ largeDesktop: 'default' })} {
        ${defaultStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
      ${getThemeSelectors({ largeDesktop: 'inverse' })} {
        ${inverseStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
    }
    ${mediaQueryUp.extraLargeDesktop} {
      ${getThemeSelectors({ extraLargeDesktop: 'default' })} {
        ${defaultStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
      ${getThemeSelectors({ extraLargeDesktop: 'inverse' })} {
        ${inverseStyle}
        color: var(--palette-neutral-surface-normal-contrast);
      }
    }
  `
}

const ThemeStyles = css`
  :root {
    ${getBorderRadiusStyles('legacy')}
    ${ShadowsStyle}
  }
  ${getPaletteScopeStyles('legacy', ':root')}
  ${getBorderRadiusScopeStyles('rebrand', `.${REBRAND_PALETTE_CLASS}`)}
  ${getPaletteScopeStyles('rebrand', `.${REBRAND_PALETTE_CLASS}`)}
`

export default ThemeStyles
